export default __webpack_public_path__ + "d008c0206f98fa887eb93b665071b96f.svg";